export default __webpack_public_path__ + "locales/lo-LA/FormFillingTipsDialog.json?hash=835afc74326ee0121dd238a80ee78ac1";